import { useDispatch } from "react-redux";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import NotFound from "../../pages/NotFound/NotFound";
import { E_ChannelOptions } from "../../globalTypes/GlobalTypes";
import { updateLoadingState } from "../Feature_Loading/Loading_Slice";
import { isEmpty } from "lodash";
import { T_CreateOrderResponse, T_SummaryData } from "./Homeloan_Types";
import { useHLBaseDataLoader } from "./BaseDataInit/HomeLoan_Init_BaseData";
import CustomPolicyOrAccountSelect from "../../components/CustomPolicyOrAccountSelect/CustomPolicyOrAccountSelect";
import { HlLobCode } from "../../utils/constants";
const HomeLoanGuard = () => {
  const dispatch = useDispatch();
  const { state, pathname, search } = useLocation();
  const csAppSlice = useAppSelector((st) => st.CsAppSlice);
  const allSummaryData: T_SummaryData[] = useAppSelector(
    (state) => state.HomeLoanSlice.summaryData
  );
  const paymentInfo: T_CreateOrderResponse = useAppSelector(
    (state) => state.HomeLoanSlice.paymentInfo
  );
  const accountNumber =
    state?.accountNumber || paymentInfo?.payment_data?.product_id || "";

  const navigate = useNavigate();
  const { isFetching, error } = useHLBaseDataLoader(accountNumber);

  useEffect(() => {
    if (isFetching) {
      dispatch(updateLoadingState(true));
    } else {
      dispatch(updateLoadingState(false));
    }
  }, [isFetching]);

  const onPolicyAccountNumberSelection = (accountNumber: string) => {
    navigate(pathname + search, { replace: true, state: { accountNumber } });
  };

  if (isEmpty(accountNumber) && !error && !isFetching) {
    return (
      <CustomPolicyOrAccountSelect
        data={{
          isOpen: true,
          options: allSummaryData.map(
            (item) => item.loan_info.rows[0].LOAN_ACCOUNT_NUMBER
          ),
          lobDetails: {
            lobId: HlLobCode,
            lobName: "",
            lob: HlLobCode,
            uniqueId: true,
          },
          redirectionUrl: "",
        }}
        policyOrAccountDataHandler={onPolicyAccountNumberSelection}
        fromGuard={true}
      />
    );
  }

  return error ? (
    <NotFound
      hideButton={csAppSlice.channel != E_ChannelOptions.CSAPP}
      moduleName="HL"
      pageName="HomeLoanGuard"
      errorTitle=""
      errorMessage={error}
    />
  ) : isFetching ? (
    <></>
  ) : (
    <Outlet />
  );
};

export default HomeLoanGuard;
